<div class="size-full flex items-center justify-center">
  <nz-result class="opacity-75" nzStatus="404" nzSubTitle="No content found." />
</div>
